export const NOT_RISK = 8003 // 未做过风险测评
export const RISK_RANK_EXPIRED = 8004 // 风险测评过期
export const RISK_BUY = 5002 // 超出风险
export const RISK_NO_BUY = 5001 // 不能购买
export const NO_SUPPORT_BANK = 3006 // 不支持银行卡
export const DON_BUY = 5001 // 不能购买
export const NO_TOKEN = 8008 // 无token
export const NO_ACCOUNT = 2001 //未开户，未绑定微信
export const OFF_LINE = 2009 // 离线状态
export const TOKEN_PASTDUE = 8006 // token过期
export const NO_BIND = 2010 // 账号未绑定微信号
export const NO_SAME_BIND = 2011 // 账号绑定微信号和当前微信号不一样
export const NO_BINDCARD = 9001 // 账号未绑卡
export const UNFIT_IDENTITY = 2012 // 身份证或手机号码与微信号不符合
export const FUND_CODE_NOT_FIND = 4001 // 身份证或手机号码与微信号不符合

export const IDENTITY_ERROR = 2020 // 证件件错误// 名字错误，证件日期过期等
export const TRADEPWD_ERROR = 9034 // 交易密码错误


// 8008 参数异常/错误
// 8007 参数为空


// WEBPACK FOOTER //
// ./src/assets/js/public/code.js